/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EIfapmeSide {
    Walter = 'Walter',
    Hope = 'Hope'
}


export function EIfapmeSideFromJSON(json: any): EIfapmeSide {
    return EIfapmeSideFromJSONTyped(json, false);
}

export function EIfapmeSideFromJSONTyped(json: any, ignoreDiscriminator: boolean): EIfapmeSide {
    return json as EIfapmeSide;
}

export function EIfapmeSideToJSON(value?: EIfapmeSide | null): any {
    return value as any;
}

